import React from 'react';

import { ClientProductCalculation } from 'types/clientProductTypes';
import { useServices } from 'hooks/useServices';
import { useAsyncBoundary } from 'utils/asyncBoundary/asyncBoundaryHooks';
import { ClientProductFormValues } from 'types/clientProductFormTypes';
import { M8ProductType } from 'services/production/types';

type Params = {
  clientId: number;
  m8ProductType: M8ProductType;
  initialCalculation: ClientProductCalculation;
  formValues: ClientProductFormValues;
};

export const useClientProductCalculation = (
  params: Params
): ClientProductCalculation => {
  const { clientId, initialCalculation, formValues, m8ProductType } = params;

  const { injectPromise } = useAsyncBoundary();

  const { calculateClientProduct } = useServices();

  const [
    clientProductCalculation,
    setClientProductCalculation,
  ] = React.useState<ClientProductCalculation>(initialCalculation);

  React.useEffect(() => {
    let canceled = false;

    const promise = calculateClientProduct({
      clientId,
      formValues,
      m8ProductType,
    }).then((productCalculation) => {
      if (!canceled) {
        setClientProductCalculation(productCalculation);
      }
    });

    injectPromise(promise, { shouldShowFallback: false });

    return () => {
      canceled = true;
    };
  }, [
    calculateClientProduct,
    clientId,
    formValues,
    injectPromise,
    m8ProductType,
  ]);

  return clientProductCalculation;
};
